import React from "react";
import { Card, Col, Row, Badge, Alert } from "react-bootstrap";
import { Link } from "react-router-dom";
import ModuleDisplayEmail from "../../../../UI/modules/fieldsDisplay/ModuleDisplayEmail";
import ModuleDisplayPhone from "../../../../UI/modules/fieldsDisplay/ModuleDisplayPhone";
import ModuleDisplayDate from "../../../../UI/modules/fieldsDisplay/ModuleDisplayDate";
import ReactFancyBox from "react-fancybox";
import orderPending from "../../../../../images/return.png";
import orderCancel from "../../../../../images/cancelled.png";
import orderCompleted from "../../../../../images/check.png";

const Details = ({ item }) => {
  const statusBadge = {
    0: (
      <Badge bg="warning" text="dark">
        Pending
      </Badge>
    ),
    1: <Badge bg="success">Approved</Badge>,
    2: <Badge bg="danger">Rejected</Badge>,
  };

  return (
    <Row>
      <Col>
        <Card className="shadow-sm border-0 mb-3">
          {/* HEADER */}
          <Card.Header className="bg-white border-0 pb-0">
            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-center">
                <img
                  src={
                    item.status === "0"
                      ? orderPending
                      : item.status === "2"
                      ? orderCancel
                      : orderCompleted
                  }
                  alt="status"
                  className="me-3"
                  style={{ width: 50 }}
                />
                <div>
                  <Link
                    to={`/orders/${item?.order?._id}`}
                    className="fw-semibold text-custom-2 text-decoration-none"
                  >
                    <h5 className="mb-0 text-custom-2 fw-bold">
                      {item?.order?.orderId}
                    </h5>
                  </Link>
                  <small className="text-muted">
                    Return ID: {item._id.slice(-8).toUpperCase()}
                  </small>
                </div>
              </div>

              <div className="d-flex  align-items-center justify-content-end">
                <div className=" mt-1 me-2">
                  {statusBadge[item.status] || (
                    <Badge bg="secondary">Unknown</Badge>
                  )}
                </div>
                <div className="badge badge-light small mt-1">
                  Submitted: <ModuleDisplayDate value={item.createdAt} />
                </div>
              </div>
            </div>
          </Card.Header>

          <Card.Body className="pt-3">
            <Row>
              {/* LEFT SIDE - General Info */}
              <Col md={5}>
                {/* CUSTOMER INFO */}
                {item.customer && (
                  <Card className="border-0 shadow-sm mb-3">
                    <Card.Header className="py-2 px-3 border-0 bg-custom-6 rounded-t-lg">
                      <h6 className="text-md text-white mb-0 fw-bold">
                        Customer
                      </h6>
                    </Card.Header>
                    <Card.Body className="p-3 bg-white rounded-bottom">
                      <Link
                        to={`/customers/${item?.customer?._id}`}
                        className="fw-semibold text-custom-2 text-decoration-none"
                      >
                        <p className="mb-1">
                          <strong>Name:</strong> {item.customer.fullName}
                        </p>
                        <p className="mb-1">
                          <strong>Email:</strong>{" "}
                          <ModuleDisplayEmail value={item.customer.email} />
                        </p>
                        <p className="mb-1">
                          <strong>Mobile:</strong>{" "}
                          <ModuleDisplayPhone value={item.customer.mobile} />
                        </p>
                      </Link>
                    </Card.Body>
                  </Card>
                )}

                {/* PRODUCT INFO */}
                {item.product && (
                  <Card className="border-0 shadow-sm mb-3">
                    <Card.Header className="py-2 px-3 border-0 bg-custom-6 rounded-t-lg">
                      <h6 className="text-md text-white mb-0 fw-bold">
                        Product
                      </h6>
                    </Card.Header>
                    <Card.Body className="p-3 bg-white rounded-bottom">
                      <Link
                        to={`/products/${item.product._id}`}
                        className="fw-semibold text-custom-2 text-decoration-none"
                      >
                        {item.product.title}
                      </Link>
                    </Card.Body>
                  </Card>
                )}
              </Col>

              {/* RIGHT SIDE - Return Details */}
              <Col md={7}>
                <Card className="border-0 shadow-sm mb-3">
                  <Card.Header className="py-2 px-3 border-0 bg-custom-6 rounded-t-lg">
                    <h6 className="text-md text-white mb-0 fw-bold">
                      Return Details
                    </h6>
                  </Card.Header>
                  <Card.Body className="p-3 bg-white rounded-bottom">
                    <div className="mb-3 border-bottom pb-2 d-flex justify-content-between align-items-start">
                      <strong>Reason:</strong>
                      <p className="text-custom-3 text-bold text-end mb-0 ms-3 flex-grow-1">
                        {item.reason || "—"}
                      </p>
                    </div>

                    <div className="mb-3 border-bottom pb-2 d-flex justify-content-between align-items-start">
                      <strong>Comments:</strong>
                      <p className="text-custom-2 small text-end mb-0 ms-3 flex-grow-1">
                        {item.message || "—"}
                      </p>
                    </div>

                    {item.image && (
                      <div className="">
                        <div className="d-flex justify-content-between align-items-start">
                          <strong>Proof Image:</strong>
                          <div className="ms-3 galleryImage">
                            <ReactFancyBox
                              thumbnail={`${process.env.REACT_APP_BACKEND_URL}public/${item.image}`}
                              image={`${process.env.REACT_APP_BACKEND_URL}public/${item.image}`}
                              caption="Return Proof"
                            />
                          </div>
                        </div>
                      </div>
                    )}
                    {item.adminComments && item.status === "1" && (
                      <Alert className="alert-custom-3 d-flex mb-1  flex-wrap p-1 font-small">
                        <strong className="me-1 mt-1 text-custom-1">
                          Admin Comments:
                        </strong>
                        <div className=" d-flex align-items-center flex-wrap p-1 font-small">
                          <span className="font-small text-normal text-custom-1 html">
                            {item.adminComments}
                          </span>
                        </div>
                      </Alert>
                    )}
                    {item.adminComments && item.status === "2" && (
                      <Alert className="alert-custom-1 d-flex mb-1  flex-wrap p-1 font-small">
                        <strong className="me-1 mt-1 text-custom-3">
                          Admin Comments:
                        </strong>
                        <div className=" d-flex align-items-center flex-wrap p-1 font-small">
                          <span className="font-small text-normal text-custom-3 html">
                            {item.adminComments}
                          </span>
                        </div>
                      </Alert>
                    )}
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export default Details;
